import React, { FC, useEffect, useState } from "react";
import { UseFormRegister, UseFormResetField, UseFormSetError, UseFormSetValue } from "react-hook-form";
import {
    DateInput,
    FormHeading,
    Loading,
    LoginButton,
    LoginInput,
    SixBoxError
} from "../Styles";
import { InputAdornment } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faCake, faSquareEnvelope } from "@fortawesome/free-solid-svg-icons";
import TextMaskCustom from "./MFAMask";
import { FormData } from "../../data/interfaces/dataMessage";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import {UserData, NewUserData} from "../../data/interfaces/userInfo";
import FadeLoader from "react-spinners/PulseLoader";

interface NewMFAProps {
    errors: any;
    register: UseFormRegister<FormData>;
    setFormData: UseFormSetValue<FormData>;
    user: NewUserData;
    setUserInfo: React.Dispatch<React.SetStateAction<NewUserData>>;
    setFormError: UseFormSetError<FormData>;
    resetFormError: UseFormResetField<FormData>;
    loginPaused: boolean;
}

const NewMFA: FC<NewMFAProps> = (props) => {

    const [birthday, setBirthday] = useState<Dayjs | null | unknown>((props.user && props.user.birthDate) ? dayjs(props.user.birthDate) : "");
    const [values, setValues] = useState<string>((props.user.mfaPhone != undefined && props.user.mfaPhone !="undefined")  ? props.user.mfaPhone : "");
    const [hasError, setHasError] = useState(false);
    const [hasBdayError, setHasBdayError] = useState(false);


    useEffect(() => {
        if (values){
            props.setFormData("Phone", values)
        }
        else{
            props.setFormData("Phone", "")
        }
    });

    useEffect(() => {
        props.setFormData("DOB", dayjs(birthday as string).format('YYYY-MM-DD'))
    });

    useEffect(() => {
        if (props.errors.Email) {
            setHasError(true)
        }
        else {
            setHasError(false)
        }
        if (props.errors.UFDOB) {
            setHasBdayError(true)
        }
        else {
            setHasBdayError(false)
        }
        props.setFormData("UserId", props.user.userId)
    });

    const handleBirthday = (e: any) => {
        const inputDate = dayjs(e)
        const formattedDate = inputDate.format('YYYY-MM-DD')
        setBirthday(inputDate)
        props.setFormData("DOB", formattedDate)
        props.resetFormError("DOB")
        setHasBdayError(false)
    }

    const handlePhone = (e: any) => {
        const number = e.target.value.replace(/\D/g, '')
        setValues(e.target.value);
        props.setFormData("Phone", number)
    }

    const validateNewMFA = (v: string | undefined | null): boolean => {
        let result = true;

        if (v) {
            const emailRegex = /^[a-zA-Z0-9-_.]+@[a-zA-Z0-9-_.]+\.[a-zA-Z]{2,}$/;
            result = emailRegex.test(v);
        }

        return ((!!v || (!!values)) && result && ((values.length === 14) || values.length === 0));
    }

    const validateBirthday = (value: string): boolean => {
        
        if((!value && birthday) || (value && !/[a-zA-Z]/.test(value))){
            value = (birthday as Dayjs).format('MM/DD/YYYY')
        }
        
        return (!!value && !/[a-zA-Z]/.test(value) && value.length === 10 && Number(value.slice(-4)) > 1901 && (dayjs(value) < dayjs().add(-1,"day")))
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <FormHeading>Secure your account with MFA</FormHeading>
            <div className="input-container">
                <LoginInput
                    id='phone'
                    label='Phone #'
                    size="small"
                    placeholder={"(000) 000-0000"}
                    inputProps={{
                        onChange: (event) => handlePhone(event),
                        value: values
                    }}
                    InputProps={{
                        inputComponent: TextMaskCustom as any,
                        startAdornment: (
                            <InputAdornment position='start'>
                                <FontAwesomeIcon icon={faPhone} />
                            </InputAdornment>
                        )
                    }}
                />
                <LoginInput
                    id='email'
                    label='Email Address'
                    size='small'
                    placeholder="User@Everlogic.com"
                    defaultValue={props.user.email}
                    {...props.register("Email", { validate: { CheckMFA: v => validateNewMFA(v) || "Please enter a valid phone # and/or email address." } })}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position='start'>
                                <FontAwesomeIcon icon={faSquareEnvelope} />
                            </InputAdornment>
                        )
                    }}
                />
                <DateInput
                    label="Birthday"
                    value={!!birthday ? birthday : null }
                    size='small'
                    {...props.register(`UFDOB`, { validate: { CheckMFABDay: v => validateBirthday(v) || "Please enter a valid birthdate." } })}
                    onChange={(event) => { handleBirthday(event); }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position='start'>
                                <FontAwesomeIcon icon={faCake} />
                            </InputAdornment>
                        )
                    }}
                />
                <LoginButton
                    variant='contained'
                    size='large'
                    type="submit"
                    disableElevation
                    disabled={props.loginPaused ? true : false}>
                    Save
                    {props.loginPaused && (<Loading><FadeLoader color={"white"} size={7} /></Loading>)}
                </LoginButton>
                <div style={{paddingTop: '10px', height: '30px'}}>
                    {hasError && props.errors.Email && (<SixBoxError>{props.errors.Email.message}</SixBoxError>)}
                    {hasBdayError && props.errors.UFDOB && (<SixBoxError>{props.errors.UFDOB.message}</SixBoxError>)}
                </div>
                <br />
            </div>
        </LocalizationProvider>
    );
}

export default NewMFA;